import { env } from '../env';
import { CustomerOrderItem } from '../types/customerOrder';

const BASE_URL = env.apiUrl;

function authHeaders(accessToken: string): HeadersInit {
  return { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' };
}

export interface OrderFilters {
  serviceGuid?: string;
  eventGuid?: string;
  status?: string;
}

export async function listOrdersAdmin(accessToken: string, filters: OrderFilters = {}): Promise<CustomerOrderItem[]> {
  const params = new URLSearchParams();
  if (filters.serviceGuid) params.set('serviceGuid', filters.serviceGuid);
  if (filters.eventGuid) params.set('eventGuid', filters.eventGuid);
  if (filters.status) params.set('status', filters.status);
  const query = params.toString();

  const res = await fetch(`${BASE_URL}/api/v1/orders/admin${query ? `?${query}` : ''}`, {
    headers: authHeaders(accessToken),
  });
  if (!res.ok) throw new Error('Failed to load orders');
  return res.json();
}

export async function cancelOrder(accessToken: string, customerOrderGuid: string): Promise<CustomerOrderItem> {
  const res = await fetch(`${BASE_URL}/api/v1/orders/${customerOrderGuid}`, {
    method: 'DELETE',
    headers: authHeaders(accessToken),
  });
  if (!res.ok) throw new Error('Failed to cancel registration');
  return res.json();
}
